import React from 'react'

export default function Hero() {
    return (
        <section id="hero" className="d-flex align-items-center">

            <div className="container">
                <div className="row">
                    <div className="col-lg-6 order-2 order-lg-1 hero-img" data-aos="zoom-in" data-aos-delay="200">
                        <img src="assets/img/hero-img.png" className="img-fluid animated" alt="" />
                    </div>
                    <div className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-1 order-lg-2" data-aos="fade-up" data-aos-delay="200">
                        <div className="row">
                            <div className="col-7 text-light">
                                <h3 style={{ fontSize: '6rem', fontWeight: '800' }}>Write</h3>
                            </div>
                        </div>
                        <div className="text-light" style={{ position: 'absolute', left: '18.5rem' }}>
                            <h3 style={{ fontSize: '12rem', fontWeight: '400' }}>it</h3>
                        </div>
                        <div className="row">
                            <div className="col-5 text-light">
                                <h3 style={{ fontSize: '7rem', fontWeight: '800' }}>Share</h3>
                            </div>
                            <div className="col-7 pt-5 px-5 mt-4">
                                <h3 >later</h3>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}
